import { Components, Theme } from '@mui/material';

export const MuiStepper = {
  defaultProps: {
    alternativeLabel: true,
    connector: null,
  },
} as Components<Theme>['MuiStepper'];

export const MuiStep = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      borderTop: '8px solid',
      borderColor: ownerState.active ? theme.palette.primary.main :
        theme.palette.neutral.surfaceVariant,
      position: 'relative',
      marginRight: theme.spacing(2),
      padding: 0,
      '&:last-of-type': {
        marginRight: 0,
      },
    }),
  }
} as Components<Theme>['MuiStep'];

export const MuiStepLabel = {
  defaultProps: {
    'data-test-id': 'step-label',
  },
  styleOverrides: {
    iconContainer: {
      display: 'none',
    },
    label: ({ theme }) => ({
      ...theme.typography.body1,
      color: theme.palette.neutral.onSurface,
      '&.Mui-active': {
        ...theme.typography.body1Bold,
      },
      '&.MuiStepLabel-alternativeLabel': {
        textAlign: 'start',
        marginTop: theme.spacing(1),
      }
    }),
  }
} as Components<Theme>['MuiStepLabel'];